import React from 'react';

import { Grid, Typography } from '@material-ui/core';

import { TextField, SelectField, Step } from '../SteppedForm';

const StepPrevnet = (props) => {
  return (
    <Step
      id="prevnet"
      title="Previous Network"
      skip={(formdata) => formdata?.onboardingFor === 'vehicle'}>
      <Typography variant="body1" class="formQuestion">
        If you have previously operated a Taxi, please provide the details below
      </Typography>
      <Grid container>
        {props.stateconfig().other_networks ? (
          <Grid item xs={12} lg={props.state?.formdata?.currentnetwork === 'Other' ? 4 : 12}>
            <SelectField
              id="currentnetwork"
              label="Current Network"
              values={[...props.stateconfig().other_networks, 'Other']}
            />
          </Grid>
        ) : (
          ''
        )}
        {!props.stateconfig().other_networks ||
        props.state?.formdata?.currentnetwork === 'Other' ? (
          <Grid item xs={12} lg={props.stateconfig().other_networks ? 8 : 12}>
            <TextField
              id="currentnetwork_text"
              label={props.stateconfig().other_networks ? 'Please specify' : 'Previous Network'}
            />
          </Grid>
        ) : (
          ''
        )}
        <Grid item xs={12} lg={props.state?.formdata?.currentnetwork_reason === 'Other' ? 4 : 12}>
          <SelectField
            id="currentnetwork_reason"
            label="Why did you leave your previous network?"
            values={props.config?.network_reasons}
          />
        </Grid>
        {props.state?.formdata?.currentnetwork_reason === 'Other' ? (
          <Grid item xs={12} lg={8}>
            <TextField id="currentnetwork_reason_other" label="Please specify" />
          </Grid>
        ) : (
          ''
        )}
      </Grid>
    </Step>
  );
};

export default StepPrevnet;
